import s from './plpbanner.module.scss'
import { useIsMobile } from '@components/common/IsMobile/useIsMobile'
import { getFastlyUrl } from '@corratech/pylot-image'

type WidgetConfiguration = {
    widgetConfiguration: { [key: string]: string }
    children?: React.ReactNode
    backgroundAttributes?: { [key: string]: string }
}
const textType = 'text'
const logoType = 'logo'

const PlpBannerGroup = (props: WidgetConfiguration) => {
    const isMobile = useIsMobile()
    const {
        widgetConfiguration: {
            'brand-button-background-color': ButtonBackgroundColor,
            'brand-button-border-color': ButtonBorderColor,
            'brand-button-color': buttonColor,
            'brand-button-link': buttonLink,
            'brand-button-text': buttonText,
            'brand-content': brandContent,
            'brand-mode': brandMode,
            'brand-content-color': contentColor,
            'brand-heading': brandHeading,
            'brand-logo': brandLogo,
            'brand-show-button': showButton
        } = {},
        children,
        backgroundAttributes: {
            'data-desktop-fastly-params': desktopFastlyParams,
            'data-mobile-fastly-params': mobileFastlyParams,
            'data-background-color': backgroundColor,
            'data-background-size': backgroundSize,
            'data-background-position': backgroundPosition,
            'data-background-attachment': backgroundAttachment,
            'data-background-repeat': backgroundRepeat,
            'data-min-height': minHeight,
            'data-max-height': maxHeight,
            'data-element': element,
            desktop_image,
            mobile_image
        } = {}
    } = props

    const getfastlyConfig = () => {
        const defaultConfig = isMobile
            ? { width: 375, height: 220 }
            : { width: 1440, height: 270 }
        const fastlyParams = isMobile ? mobileFastlyParams : desktopFastlyParams

        return fastlyParams ? JSON.parse(fastlyParams) : defaultConfig
    }

    const getfastlyConfigBrand = () => {
        if (isMobile) {
            return { height: 140, quality: 100 }
        }
        return { height: 180, quality: 100 }
    }
    const fastlyImageUrl = getFastlyUrl({
        src: isMobile ? mobile_image : desktop_image,
        ...getfastlyConfig()
    })

    const logoFastlyUrl = getFastlyUrl({
        src: brandLogo,
        ...getfastlyConfigBrand()
    })

    const backgroundStyle = {
        backgroundColor,
        backgroundSize,
        backgroundPosition,
        backgroundAttachment,
        backgroundRepeat,
        backgroundImage: `url(${fastlyImageUrl})`,
        minHeight,
        maxHeight
    }

    return (
        <div
            className={s.authenticityAndInnovation}
            style={backgroundStyle}
            {...(element && { 'data-element': element })}
        >
            {brandMode === logoType && brandLogo && (
                <img
                    src={logoFastlyUrl}
                    // eslint-disable-next-line i18next/no-literal-string
                    alt="Brand Logo"
                    className={s.brandLogo}
                    loading="lazy"
                />
            )}
            {brandMode === textType && (
                <div className={s.textContainer}>
                    {brandHeading && (
                        <h1
                            style={{ color: contentColor }}
                            className={s.brandHeading}
                        >
                            {brandHeading}
                        </h1>
                    )}
                    {brandContent && (
                        <p
                            style={{ color: contentColor }}
                            className={s.brandContent}
                        >
                            {brandContent}
                        </p>
                    )}
                    {showButton && buttonLink && (
                        <a
                            href={buttonLink}
                            className={s.buttonContainer}
                            style={{
                                backgroundColor: ButtonBackgroundColor,
                                borderColor: ButtonBorderColor,
                                color: buttonColor
                            }}
                        >
                            {buttonText}
                        </a>
                    )}
                </div>
            )}

            {children}
        </div>
    )
}

export default PlpBannerGroup
